import { addCommas } from "@persian-tools/persian-tools";
import React, { useContext } from "react";
import { HiPlus } from "react-icons/hi";
import { pathMaker } from "utils/helperFunctions";
import ikea from "../../assets/images/maleki/ikea-png.jpg";
import { Link, NavLink, useNavigate } from "react-router-dom";
import AuthenticationContext from "context/Authentication/AuthenticationContext.ts";
import AdminOperation from "components/admin-panel/AdminOperation";
import logo from "../../assets/images/logo/logo.png";

const ProductCard = ({
  data,
  isCategory = false,
  isHashtag = false,
  customClass = "",
}) => {
  const navigate = useNavigate();

  const { userInfo } = useContext(AuthenticationContext);

  function calculateOriginalPrice(discountedPrice, discountPercentage) {
    return Math.trunc(discountedPrice / (1 - discountPercentage / 100));
    // return discountedPrice + discountPercentage;
  }
  console.log(
    "object",
    data?.product_prices?.length > 0 &&
      data?.product_prices?.every((v) => v?.inventory != 0)
  );
  return (
    <div
      className={`pointer d-flex flex-column position-relative ${customClass} ${
        isCategory
          ? "col-6 col-md-4 col-lg-3 col-xl-2 border pd-16 "
          : "swiper_amazing-card w-100 h-100"
      }`}
    >
      {userInfo.userType == 0 && (
        <AdminOperation
          id={data?.id}
          status={data?.status}
          left="0"
          top="10"
          productData={data}
        />
      )}
      <Link
        to={`/product/${data.id}`}
        // target="_blank"
        className={`text-decoration-none `}
      >
        <div
        //  onClick={() => navigate(`/product/${data.id}`)}
        >
          <div
            className="swiper_amazing-pic mb-2"
            style={{ display: "flex", justifyContent: "center" }}
          >
            {isCategory && isHashtag ? (
              <img
                src={
                  data.file !== null && data.file !== ""
                    ? pathMaker(data.file)
                    : logo
                }
                style={{
                  objectFit: "contain",
                  height: "150px",
                  width: "150px",
                }}
              />
            ) : isCategory ? (
              <img
                src={
                  data.file !== null && data.file !== ""
                    ? pathMaker(data.file)
                    : logo
                }
                style={{
                  objectFit: "contain",
                  height: "150px",
                  width: "150px",
                }}
              />
            ) : (
              <img
                src={
                  data.file !== null && data.file !== ""
                    ? pathMaker(data.file)
                    : logo
                }
                style={{ height: "160px", width: "100%" }}
              />
            )}
          </div>
          <Link
            to={`/product/${data.id}`}
            // target="_blank"
            className={`product-title font-12-600 two-line text-decoration-none text-start `}
          >
            {data.title}
          </Link>
          {data?.product_prices?.length == 0 ||
          data?.product_prices?.every((v) => v?.inventory == 0) ? (
            <div className="flex-grow-1 d-flex flex-column justify-content-end">
              <div className=" d-flex justify-content-end font-12-600 flex-shrink-1">
                <span className="regular-font" style={{ color: "maroon" }}>
                  ناموجود{" "}
                </span>
              </div>
            </div>
          ) : (
            <div className="flex-grow-1 d-flex flex-column justify-content-end">
              <div className="swiper_amazing-prices font-12-600">
                <div className="swiper_amazing-discount d-flex justify-content-end align-items-end">
                  {+data.max_discount !== 0 ? (
                    <div className="swiper_amazing-dis">
                      <span className="text-decoration-line-through fs-12 font-12-600">
                        {/* {addCommas(
                          calculateOriginalPrice(
                            +data.min_price,
                            +data.max_discount
                          )
                        )} */}
                        {addCommas(Math.trunc(+data.min_price))}
                        تومان
                      </span>
                    </div>
                  ) : (
                    ""
                  )}

                  {+data.max_discount !== 0 ? (
                    <div className="discount-percent font-12-700 wh-28 d-flex align-items-center justify-content-center rd-6 text-white mr-r-6">
                      <span>{data.max_discount}%</span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="swiper_amazing-price d-flex justify-content-end font-12-600 flex-shrink-1">
                <span className="regular-font">
                  {addCommas(
                    Math.trunc(
                      +data.min_price -
                        +data.min_price * (+data.max_discount / 100)
                    )
                  )}{" "}
                  تومان
                </span>
              </div>
            </div>
          )}

          <Link
            to={`/product/${data.id}`}
            className="position-absolute bg-secondary rounded "
            style={{
              right: isCategory ? "16px" : "9px",
              bottom: isCategory ? "16px" : "9px",
            }}
            // target="_blank"
          >
            <HiPlus
              style={{
                color: "white",
                width: 24,
                height: 24,
                padding: 0,
                margin: 0,
              }}
            />
          </Link>
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;
